import React from 'react';
import { motion } from 'framer-motion';
import { CalendarX, Map, HelpCircle, MessageSquareWarning, TrendingDown, SearchX, Activity, FileX, Baby, Trophy, Users, Clock } from 'lucide-react';
export function ProblemAgitation() {
  const problems = [{
    icon: <CalendarX data-id="element-196" />,
    title: 'Sin planificación',
    desc: 'Improvisás la temporada semana a semana sin saber qué viene después'
  }, {
    icon: <Map data-id="element-197" />,
    title: 'Prácticas sin rumbo',
    desc: 'Llegás a la cancha sin saber bien qué vas a trabajar ese día'
  }, {
    icon: <HelpCircle data-id="element-198" />,
    title: 'No sabés qué enseñar',
    desc: 'No tenés claro qué contenidos son apropiados para cada edad'
  }, {
    icon: <MessageSquareWarning data-id="element-199" />,
    title: 'Quilombo con padres',
    desc: 'No sabés cómo manejar al padre que te cuestiona o te manda WhatsApps a las 11pm'
  }, {
    icon: <TrendingDown data-id="element-200" />,
    title: 'Pibes que no progresan',
    desc: 'Sentís que el esfuerzo que metés no se refleja en el nivel del equipo'
  }, {
    icon: <SearchX data-id="element-201" />,
    title: 'Sin herramientas',
    desc: 'Buscás ejercicios en YouTube pero no encontrás nada ordenado ni adaptado'
  }, {
    icon: <Activity data-id="element-202" />,
    title: 'Físico sin criterio',
    desc: 'No sabés cuánto exigirles físicamente sin pasarte de la raya y arriesgar lesiones'
  }, {
    icon: <FileX data-id="element-203" />,
    title: 'Sin registros',
    desc: 'Anotás en papeles sueltos que perdés y terminás la temporada sin datos de nada'
  }];
  const audiences = [{
    icon: <Baby data-id="element-204" />,
    title: 'Profe de Escuelita',
    desc: 'Trabajás con Baby y Mini Básquet y querés un sistema que funcione con nenes de 5 a 10 años'
  }, {
    icon: <Trophy data-id="element-205" />,
    title: 'DT de Inferiores',
    desc: 'Entrenás Infantiles, Cadetes o Juveniles en un club de barrio o del interior y querés dejar de improvisar'
  }, {
    icon: <Users data-id="element-206" />,
    title: 'Manejás varias categorías',
    desc: 'Tenés a cargo 2 o 3 categorías al mismo tiempo y necesitás un sistema que escale sin volverse loco',
    badge: 'FRECUENTE'
  }, {
    icon: <Clock data-id="element-207" />,
    title: 'Entrenás voluntario',
    desc: 'Tenés trabajo o estudio, entrenás a la tarde y querés ser más profesional aunque el tiempo sea poco'
  }];
  return <section className="bg-brand-light py-12 md:py-20" data-id="element-208">
      {/* Pain Points */}
      <div className="max-w-6xl mx-auto px-4 mb-14 md:mb-24" data-id="element-209">
        <div className="text-center mb-6 md:mb-12" data-id="element-210">
          <h3 className="text-brand-orange font-bold tracking-widest uppercase text-xs md:text-sm mb-2" data-id="element-211">
            ¿Te pasa esto?
          </h3>
          <h2 className="font-display text-2xl md:text-5xl text-brand-dark leading-tight" data-id="element-212">
            SI ENTRENÁS BÁSQUET EN ARGENTINA, ESTO TE SUENA FAMILIAR
          </h2>
        </div>

        {/* Stacked rows on mobile, 2-col rows on desktop */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 md:gap-3 max-w-4xl mx-auto" data-id="element-213">
          {problems.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} whileHover={{
          x: 4
        }} className="bg-white p-3 md:p-4 rounded-xl shadow-sm border border-gray-100 hover:border-brand-orange hover:shadow-md transition-all flex items-center gap-3 md:gap-4" data-id="element-214">
              <div className="text-brand-orange bg-orange-50 w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center shrink-0 [&>svg]:w-5 [&>svg]:h-5 md:[&>svg]:w-6 md:[&>svg]:h-6" data-id="element-215">
                {p.icon}
              </div>
              <div className="min-w-0 flex-grow" data-id="element-216">
                <h4 className="text-sm md:text-base mb-0.5 text-brand-dark leading-tight font-[600]" data-id="element-217">
                  {p.title}
                </h4>
                <p className="text-gray-600 text-xs md:text-sm leading-snug" data-id="element-218">
                  {p.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mt-8 md:mt-12" data-id="element-219">
          <p className="font-display text-xl md:text-3xl text-brand-dark leading-tight" data-id="element-220">
            <span className="marker-highlight" data-id="element-221">
              ¿Cuántas temporadas más vas a improvisar?
            </span>
          </p>
        </div>
      </div>

      {/* Target Audience */}
      <div className="max-w-6xl mx-auto px-4" data-id="element-222">
        <div className="text-center mb-6 md:mb-12" data-id="element-223">
          <h3 className="text-brand-orange font-bold tracking-widest uppercase text-xs md:text-sm mb-2" data-id="element-224">
            ¿Para quién es?
          </h3>
          <h2 className="font-display text-2xl md:text-5xl text-brand-dark leading-tight" data-id="element-225">
            DISEÑADO PARA VOS SI SOS PROFE DE BÁSQUET
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-3 md:gap-6" data-id="element-226">
          {audiences.map((a, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} whileHover={{
          y: -3
        }} className={`relative bg-white p-4 md:p-8 rounded-2xl border-2 ${a.badge ? 'border-brand-orange shadow-lg' : 'border-gray-200'} flex items-start gap-3 md:gap-6 transition-shadow hover:shadow-md`} data-id="element-227">
              {a.badge && <div className="absolute -top-3 right-4 md:right-6 bg-brand-orange text-white text-[10px] md:text-xs font-bold px-2 py-0.5 md:px-3 md:py-1 rounded-full uppercase tracking-wider" data-id="element-228">
                  {a.badge}
                </div>}
              <div className={`p-2.5 md:p-4 rounded-xl shrink-0 ${a.badge ? 'bg-brand-orange text-white' : 'bg-gray-100 text-brand-dark'} [&>svg]:w-6 [&>svg]:h-6 md:[&>svg]:w-8 md:[&>svg]:h-8`} data-id="element-229">
                {a.icon}
              </div>
              <div data-id="element-230">
                <h4 className="font-display text-base md:text-2xl mb-1 md:mb-2 text-brand-dark leading-tight" data-id="element-231">
                  {a.title}
                </h4>
                <p className="text-gray-600 text-xs md:text-base font-medium leading-snug md:leading-relaxed" data-id="element-232">
                  {a.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mt-8 md:mt-10" data-id="element-233">
          <p className="text-gray-500 text-sm md:text-base font-medium" data-id="element-234">
            ¿No estás seguro si es para vos?{' '}
            <span className="text-brand-orange font-bold" data-id="element-235">
              Tenés 7 días de garantía →
            </span>
          </p>
        </div>
      </div>
    </section>;
}